export default {"src":"/_next/static/media/ic_random_button.cebcb30c.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};